import 'bootstrap/dist/css/bootstrap.css';
//import 'react-select/dist/react-select.css';
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js